import React from "react";
import { IoMdClose } from "react-icons/io";
import { FaUser } from "react-icons/fa";
import { FaRegHandshake } from "react-icons/fa";
import { FaListOl } from "react-icons/fa";
import { FaLayerGroup } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
import { FaAddressBook } from "react-icons/fa";
import { MdInsights } from "react-icons/md";
import { useProjects } from "../../utils/projects";
import ProjectLogo from "../../Components/ProjectLogo/ProjectLogo";

const SideBar = ({isSidebarOpen, toggleSidebar, activeMenuItem, setActiveMenuItem}) =>{

    const handleMenuItemClick = (menuItem) => {
        setActiveMenuItem(menuItem);
      };

    // Admin-added projects get their own entry, like Sovereign Park / Vatika
    const { projects } = useProjects();
    const addedProjects = projects.filter((project) => !project.builtIn);

    return(
        <div className={`left_sidebar ${isSidebarOpen ? "open" : ""}`}>
        <button className='close_btn' onClick={toggleSidebar}>
          {" "}
          <IoMdClose />
        </button>
        <div className='logo '>
          <h2>
            <img src='/assets/infra-logo-b.png' alt='' />
          </h2>
        </div>
        <div className='main_content'>
          <div className='menu_items'>
            <div
              className={`menu_item ${
                activeMenuItem === "overview" && "active"
              }`}
              onClick={() => handleMenuItemClick("overview")}
            >
              <MdInsights style={{width:"30px",height:"30px"}}/>
              <p>Overview</p>
            </div>
            <div
              className={`menu_item ${
                activeMenuItem === "dashboard" && "active"
              }`}
              onClick={() => handleMenuItemClick("dashboard")}
            >
              <FaListOl style={{width:"30px",height:"30px"}}/>
              <p>{" "}Recent Visit's {" "}</p>
            </div>
            <div
              className={`menu_item ${
                activeMenuItem === "calendar-vatika" && "active"
              }`}
              onClick={() => handleMenuItemClick("calendar-vatika")}
            >
              <ProjectLogo name="Vatika Seven Elements" size={22} />
              <p>Vatika Seven Element Visitor's</p>
            </div>
            <div
              className={`menu_item ${
                activeMenuItem === "calendar-sovereign" && "active"
              }`}
              onClick={() => handleMenuItemClick("calendar-sovereign")}
            >
              <ProjectLogo name="Sovereign Park" size={22} />
              <p>Sovereign Park Visitor's</p>
            </div>
               <div
              className={`menu_item ${
                activeMenuItem === "calendar-saan-verdante" && "active"
              }`}
              onClick={() => handleMenuItemClick("calendar-saan-verdante")}
            >
              <ProjectLogo name="Saan Verdante" size={22} />
              <p>Saan Verdante</p>
            </div>
            {addedProjects.map((project) => (
              <div
                key={project.name}
                className={`menu_item menu_item--project ${
                  activeMenuItem === `project:${project.name}` && "active"
                }`}
                onClick={() => handleMenuItemClick(`project:${project.name}`)}
              >
                <ProjectLogo name={project.name} size={22} />
                <p>{project.name}</p>
              </div>
            ))}
            <div
              className={`menu_item ${
                activeMenuItem === "projects" && "active"
              }`}
              onClick={() => handleMenuItemClick("projects")}
            >
              <FaLayerGroup style={{width:"30px",height:"30px"}}/>
              <p>Projects</p>
            </div>
            <div
              className={`menu_item ${
                activeMenuItem === "Channel-Partner" && "active"
              }`}
              onClick={() => handleMenuItemClick("Channel-Partner")}
            > 
            <FaRegHandshake style={{width:"30px",height:"30px"}}/>
              <p>CP Date</p>
            </div>
            <div
              className={`menu_item ${
                activeMenuItem === "brokers" && "active"
              }`}
              onClick={() => handleMenuItemClick("brokers")}
            >
            <FaAddressBook style={{width:"30px",height:"30px"}}/>
              <p>Channel Partners</p>
            </div>
            <div
              className={`menu_item ${
                activeMenuItem === "Users" && "active"
              }`}
              onClick={() => handleMenuItemClick("Users")}
            > 
            <FaUser style={{width:"30px",height:"30px"}}/>
              <p>Sales List</p>
            </div>
            <div
              className={`menu_item ${
                activeMenuItem === "rms" && "active"
              }`}
              onClick={() => handleMenuItemClick("rms")}
            >
            <FaUserTie style={{width:"30px",height:"30px"}}/>
              <p>RM Accounts</p>
            </div>
          </div>
        </div>
      </div>
    )
}

export default SideBar